import React from 'react';

const Editincomeadmin = () => {
  return (
    <div className='m-5'>

         
<div className="row mt-4 mb-4">
                <div className="col-lg-6 mt-3">
                  <div className="card border-0 shadow ">
                    <div className="card-header bg bg-info border-0">
                      <h4>Admin Enter RE-income</h4>
                    </div>

                    <div className="card-body">
                      <div className="col-lg-12">
                        <label for="exampleInputPassword1" class="form-label">
                        Enter RE-Income
                        </label>
                        <input
                          type="charcter"
                          class="form-control"
                          placeholder=""
                          id="exampleInputPassword1"
                        />
                      </div>

                      <div className="col-lg-12 mt-3">
                        <button className="btn btn-primary">Submit</button>
                      </div>
                    </div>
                  </div>
                </div>

                
              </div>




    </div>
  )
}

export default Editincomeadmin;